export const removeDecimalsToNumber = (num: number, precision = 2) => {
  return Number(removeDecimalsToString(num, precision));
};

export const removeDecimalsToNumberPerAcre = (
  num: number | undefined,
  acres: number | undefined,
  precision = 2
) => {
  return num && acres
    ? Number(removeDecimalsToString(num / acres, precision))
    : 0;
};

export const removeDecimalsToStringPerAcre = (
  num: number | undefined,
  acres: number | undefined,
  precision = 2
) => {
  return num && acres
    ? (Math.round((num / acres) * 100) / 100).toFixed(precision)
    : '';
};

export const removeDecimalsToString = (
  num: number | undefined,
  precision = 2
) => {
  return num ? (Math.round(num * 100) / 100).toFixed(precision) : '';
};

export const numberToStringWithCommas = (x: number | undefined) => {
  if (!x) return '0';
  const formatted = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return formatted;
};

export const letterize = (x: number | undefined | null) => {
  if (x === undefined || x === null || isNaN(x)) return '';

  const usformatter = Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumSignificantDigits: x > 1000000 ? 4 : 3
  });
  return usformatter.format(x);
};
